import { Grid } from "@mui/material";
import { motion } from "framer-motion";

const About = () => {
  return (
    <motion.div
      key={'about'}
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -10 }}
      transition={{ duration: 0.3 }}
    >
      <Grid
        container
        rowSpacing={2}
        columnSpacing={5}
        columns={{ xs: 1, md: 2, lg: 2, xl: 2 }}
      >
        <Grid item xs={1}>
          <img src={"images/profile.jpg"} width={"100%"} alt={"Profile"} />
        </Grid>
        <Grid item xs={1}>
          <p>
            From my earliest memories, animals have fascinated and inspired me. Their beauty, spirit, and connection to nature have always been a source of wonder,fueling my creativity and becoming the heart of my art.
          </p>
          <p>
            As a self-taught artist, my creative path began with simple doodles. After completing a transformative CBT course in 2017, art became a meaningful outlet that soon grew into a true passion.
          </p>
          <p>
            To honor the creatures that inspire my art, I donate 10% of every sale to animal conservation charities and projects. This commitment allows me to contribute, in my own way, to the preservation of wildlife.
          </p>
          <p>
            I live in a cosy English village with my husband and son, balancing family life, my day job, and my love for painting. No matter how busy life gets, art has become a grounding part of who I am.   </p>
          <p>
            Thank you for being here,I hope my work brings you the same sense of wonder and connection that wildlife brings to me.
          </p>
          <p>Donations : <a href="https://www.justgiving.com/page/bhagya-perera-art-donations?utm_medium=FR&utm_source=CL">https://www.justgiving.com/page/bhagya-perera-art-donations</a></p>
          <br />
          <h3>Exhibitions</h3>
          <p>2025 - Lingfield Art Exhibition, Community Centre , Lingfeild (Oct) </p>
          <p>2025 - Association of Sussex Artists , The Camelia Botnar, Horsham (Oct)</p>
          <p>2025 - Association of Animal Artists, The Station, North Yorkshire (Sept-Oct)</p>
          <p>2025 - Southern Nature Art , Rookesbury Park,Wickam (Aug)</p>
          <p>2023 - Association of Sussex Artists , Drill Hall, Horsham (July)</p>
          <p>2022 - Association of Sussex Artists , Drill Hall, Horsham (July)</p>
        </Grid>
      </Grid>
    </motion.div>
  );
};

export default About;
